import React from 'react'
import * as actions from '../../store/actions/index';

import DeleteModal from './DeleteModal';
import { useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";
import { ROUTES } from '../../routes';
import { useTranslation } from 'react-i18next';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';

const DeleteProjectModal = (props) => {

  const history = useHistory();
  const { t } = useTranslation();
  const ht = useCustomHtmlTranslation();

  const projectId = useSelector(state => state.modal.modalProps.projectId)
  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });

  const onSubmitAction = () => {
    return actions.deleteProject(projectId)
  };

  const redirectTo = () => {
    return history.push(ROUTES.TO_PROJECTS)
  };

  return (
    <DeleteModal
      modalTitle={ t( 'modal.delete_project.title' ) }
      onSubmitAction={onSubmitAction}
      redirectTo={redirectTo}
    >
    { ht('modal.delete_project.text', {projectname: thisProject(projectId).title}) }
    </DeleteModal>
  )
}

export default DeleteProjectModal



// WEBPACK FOOTER //
// ./src/components/Modals/DeleteProjectModal.js